import { defineMessage } from 'react-intl';

export const scheduleStatusMentionsHelpMessage = defineMessage({
  id: 'audit.scheduleStatusPntScreen.status.help',
  defaultMessage:
    'Los números indican matches con schedule / schedules.\n\nCompleto: todos los schedules tienen un match.\nParcial: faltan matches para cubrir todos los schedules.\nSin emisión: hay schedules y ningún match.\nSin matches: no hay matches ni schedules.\n\nEl ícono de advertencia indica que algún match está fuera de tolerancia.',
});

export const scheduleStatusMentionsNameMessage = defineMessage({
  id: 'common.text.name',
  defaultMessage: 'Nombre',
});

export const scheduleStatusMentionsContentMessage = defineMessage({
  id: 'common.text.content',
  defaultMessage: 'Contenido',
});

export const scheduleStatusMentionsConfidenceMessage = defineMessage({
  id: 'audit.scheduleStatusPntScreen.confidence',
  defaultMessage: 'Confianza',
});

export const viewDetailActionMessage = defineMessage({
  id: 'audit.schedulesListScreen.viewScheduleBtn',
  defaultMessage: 'Ver detalle',
});
